import {useId} from 'react'

const useUniqueId = (overwriteId?: string, suffix = '') => {
  const generatedId = `${useId()}${suffix}`
  return overwriteId || generatedId
}

export default useUniqueId
